import { useState } from "react";

import { useUpdateContacts } from "@/entities/mentor/api";
import { Button } from "@/shared/ui/button";
import { Input } from "@/shared/ui/input";
import { Modal } from "@/shared/ui/Modal";

export const ChangeContactsModal = () => {
  const [main, setMain] = useState<string | undefined>();
  const [reserve, setReserve] = useState<string | undefined>();

  const { mutateAsync } = useUpdateContacts();

  const handleClick = () => {
    mutateAsync({
      main,
      reserve,
    });
  };

  return (
    <Modal>
      <Modal.Trigger variant="outline">Мои контакты</Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Ваш контакт для связи</Modal.Title>
        <div className="flex flex-col gap-2">
          <label className="text-textColor">Telegram</label>
          <Input
            placeholder="Основной Telegram"
            value={main}
            onChange={(e) => setMain(e.target.value)}
          />
        </div>
        <div className="flex flex-col gap-2 text-textColor">
          <label>Резервный Telegram</label>
          <Input
            placeholder="Резервный Telegram"
            value={reserve}
            onChange={(e) => setReserve(e.target.value)}
          />
        </div>
        <Button
          className="w-full font-medium text-textColor"
          type="button"
          variant="outline"
          onClick={handleClick}
        >
          Сохранить изменения
        </Button>
        <Modal.Close />
      </Modal.Content>
    </Modal>
  );
};
